import { render, staticRenderFns } from "./OrdenesCompras.vue?vue&type=template&id=2b871128"
import script from "./OrdenesCompras.vue?vue&type=script&lang=js"
export * from "./OrdenesCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports